/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_TrialingInputs */

const en_subscription_trialing = /** @type {(inputs: Subscription_TrialingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trialing`)
};

const fr_subscription_trialing = /** @type {(inputs: Subscription_TrialingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essai`)
};

const de_subscription_trialing = /** @type {(inputs: Subscription_TrialingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erprobung`)
};

const it_subscription_trialing = /** @type {(inputs: Subscription_TrialingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prova`)
};

const ru_subscription_trialing = /** @type {(inputs: Subscription_TrialingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Испытание`)
};

const es_subscription_trialing = /** @type {(inputs: Subscription_TrialingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prueba`)
};

const zh_cn2_subscription_trialing = /** @type {(inputs: Subscription_TrialingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`试验`)
};

const ja_subscription_trialing = /** @type {(inputs: Subscription_TrialingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トライアル`)
};

const hi_subscription_trialing = /** @type {(inputs: Subscription_TrialingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परीक्षण`)
};

const pt_pt2_subscription_trialing = /** @type {(inputs: Subscription_TrialingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testando`)
};

/**
* | output |
* | --- |
* | "Trialing" |
*
* @param {Subscription_TrialingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subscription_trialing = /** @type {((inputs?: Subscription_TrialingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_TrialingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subscription_trialing(inputs)
	if (locale === "de") return de_subscription_trialing(inputs)
	if (locale === "it") return it_subscription_trialing(inputs)
	if (locale === "ru") return ru_subscription_trialing(inputs)
	if (locale === "es") return es_subscription_trialing(inputs)
	if (locale === "zh-CN") return zh_cn2_subscription_trialing(inputs)
	if (locale === "ja") return ja_subscription_trialing(inputs)
	if (locale === "hi") return hi_subscription_trialing(inputs)
	if (locale === "pt-PT") return pt_pt2_subscription_trialing(inputs)
	return en_subscription_trialing(inputs)
});